import './index.scss';
import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {Button, Popconfirm,Popover, Input, Card, Breadcrumb, Icon, message, Pagination, Table, Tooltip, Modal} from 'antd';
import moment from 'moment';
import Info from '../Detail/Info';
import ajaxUtil from '../../util/ajax';
import {style} from '../../util/image';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import Search from '../Common/Search';
import SwipeableViews from 'react-swipeable-views';
import ClockEditor from './ClockEditor';

import AddDocument from './AddDocument';
import {STATUS_MAP as VIDEO_STATUS_MAP} from '../Video/List';
const {ajax, ajaxv2, DOMAIN_CURRENT} = ajaxUtil;

const STAUTS_MAP = {
  '0':'待转换',
  '1':'正在转换',
  '2':'转换完成'
};

// console.log(VIDEO_STATUS_MAP);

const List = (props)=>{
  let {match} = props;
  let {params = {}} = match;
  const {galleryid} = params;

  const [dataSource, setDataSource] = useState([]);
  const [pagination, setPagination] = useState({
    total:0,
    pageSize:20,
    current:1
  });

  const [videoList, setVideoList] = useState([]);
  useEffect(()=>{
    Promise.all([ajaxv2({
      url:DOMAIN_CURRENT + '/api/v2/gallerymedium/list?gallery_id='+galleryid+'&page=1&page_size=100&type=video',
    }), ajaxv2({
      url:DOMAIN_CURRENT + '/api/v2/gallerymedium/list?gallery_id='+galleryid+'&page=1&page_size=100&type=live',
    })]).then(arr=>{
      let list = [];
      for(var i=0;i<arr.length;i++) {
        list = list.concat(arr[i].items);
      }

      ajaxv2({
        url:DOMAIN_CURRENT + '/api/v2/live/source/list',
        method:'GET',
        data:{
          gallery_id:galleryid,
          page_size:100
        }
      }).then(livelist=>{
        console.log();
        let livemap = {};
        (livelist.items || []).forEach(it=>{
          livemap[it.id] = it;
        })
        list = list.map(it=>{
          if(it.type == 'live' && livemap[it.source]) {
            let target = livemap[it.source];
            it.status = target.status;
            it.desc = target.title;
            it.source_detail = target;
          }
          return it;
        });
        setVideoList(list);
      });
    });
  }, []);

  const fetchList = ()=>{
    ajaxv2({
      url:'/api/v2/live/docs/list',
      data:{
        page:pagination.current,
        gallery_id:galleryid
      }
    }).then(res=>{
      setDataSource(res);
      setPagination({
        ...pagination,
        total:res.length
      });
    })
  };

  useEffect(()=>{
    fetchList();
  }, [pagination.current]);

  const columns = [
    {
      title:"文件名称",
      dataIndex:"doc_name",
      width:300,
      ellipsis:true
    },
    {
      title:"页数",
      dataIndex:"doc_result",
      render:(val)=>{
        try {
          let result = val.match(/page\_/ig);
          return <span>{result.length} <a style={{marginLeft:5}} onClick={()=>previewDocList(val)}>查看</a></span>;
        }catch(e) {
          return '--';
        }
      }
    },
    {
      title:"转换状态",
      dataIndex:'doc_status',
      render:(val)=>{
        return STAUTS_MAP[String(val)];
      }
    },
    {
      title:"上传时间",
      dataIndex:'created_at'
    },
    {
      title:"绑定视频",
      dataIndex:'medium_id',
      width:250,
      ellipsis:true,
      render:(val)=>{
        if(val) {
          return videoList.filter(it=>it.id == val).map(it=>{
            return `${it.desc}(${VIDEO_STATUS_MAP[it.status]})`;
          });
        }else {
          return <span style={{color:'#f81d22'}}>未绑定</span>;
        }
      }
    },{
      title:'操作',
      dataIndex:'id',
      render:(id, record)=>{
        let editButton = record.doc_status == 1 ?
          <Tooltip title="请等待转换完成，才能继续编辑"><a style={{marginRight:5, color:'#d0d0d0'}}>编辑</a></Tooltip> :
          <a style={{marginRight:5}} onClick={()=>setEditData(record)}>编辑</a>

        let targetVideo = videoList.find(it=>it.id == record.medium_id);
        let clockButton = null;
        if(targetVideo) {
          clockButton = targetVideo.status == 'rollback' ? <a style={{marginRight:5}} onClick={()=>{
            setClockData(record);
          }}>计时设置</a> :
            <Tooltip title="视频回放成功后，才能编辑计时设置"><a style={{marginRight:5, color: '#d0d0d0'}}>计时设置</a></Tooltip>;
        }

        return <React.Fragment>
          {clockButton}
          {editButton}
          <Popconfirm title="将同步删除该文件的翻页记录，是否继续？" onConfirm={()=>deleteItem(record)}>
            <a>删除</a>
          </Popconfirm>
        </React.Fragment>;
      }
    }
  ];

  const [previewList, setPreviewList] = useState(null);

  const previewDocList = (val)=>{
    if(typeof val == 'string') {
      try {
        val = JSON.parse(val);
      }catch(e) {}
    }

    if(val instanceof Array) {
      setPreviewList(val);
    }
  }

  const [editData, setEditData] = useState(null);
  const [clockData, setClockData] = useState(null);

  const deleteItem = (record)=>{
    ajaxv2({
      url:'/api/v2/live/docs/del/' + record.id,
      method:'POST'
    }).then(res=>{
      message.success('删除成功');
      fetchList();
    })
  };

  const onAddDocument = (data)=>{
    if(!data.doc_name) {
      message.error('请填写文件名');
      return;
    }
    if(!data.doc_origin) {
      message.error('请检查文件是否上传成功');
      return;
    }

    if(!galleryid) {
      message.error('获取相册信息失败，请联系管理员');
      return;
    }

    if(data && data.doc_origin && data.doc_origin.indexOf('http') != 0) {
      data.doc_origin = `http://image1.jfoto.cn/${data.doc_origin}`;
    }

    ajaxv2({
      url:data.id ? '/api/v2/live/docs/saveone/' + data.id : '/api/v2/live/docs/add',
      method:'POST',
      data:{
        ...data,
        gallery_id:Number(galleryid)
      }
    }).then(res=>{
      if(res && res.id) {
        message.success('操作成功');
        setEditData(null);
        fetchList();
      }else {
        message.error('操作失败');
      }
    });
  };

  const [previewIndex, setPreviewIndex] = useState(0);

  return <div className="documentlist">
    <div className="wrapper">
      <div className="operation">
        <div>
          <Button type="primary" onClick={()=>{
            setEditData({});
          }}>新增文件</Button>
        </div>
      </div>
      <div className="content">
        <Table columns={columns} dataSource={dataSource} pagination={false} footer={(currentPageData)=>{
          return <Pagination {...pagination} />
        }} />
      </div>
    </div>
    <AddDocument data={editData} videoList={videoList} galleryid={galleryid} onCancel={()=>setEditData(null)} onSubmit={onAddDocument} />
    <ClockEditor data={clockData} videoList={videoList} galleryid={galleryid} onCancel={()=>setClockData(null)} />
    <Modal visible={previewList} title={"预览转换结果"} width={750} footer={null} wrapClassName="previewresult" onCancel={()=>{
      setPreviewList(null);
      setPreviewIndex(0);
    }}>
      {previewList && previewList.length ? <div>
        <SwipeableViews enableMouseEvents index={previewIndex} onChangeIndex={(e)=>setPreviewIndex(e)} disableLazyLoading={false}>
          {previewList.filter(Boolean).map((file, index)=>{
            return <div key={file} className="bigpic-one">
              {Math.abs(previewIndex - index) < 2 ?
                <img src={style(file, 'wx_image_1')}/> :
                null}
            </div>;
          })}
        </SwipeableViews>
        <div className="arrows">
          {previewIndex > 0 ? <Icon type="left-circle" theme="filled" style={{fontSize:36}} onClick={()=>{
            setPreviewIndex(Math.max(0, previewIndex - 1));
          }} /> : <div/>}
          {previewIndex < previewList.length - 1 ? <Icon type="right-circle" theme="filled" style={{fontSize:36}} onClick={()=>{
            setPreviewIndex(Math.min(previewList.length - 1, previewIndex + 1));
          }} /> : <div/>}
        </div>
      </div> : null}
    </Modal>
  </div>;
};

export default List;



// WEBPACK FOOTER //
// ./src/components/Document/List.js